import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization/localization.service';

@Component({
  selector: 'app-language-form',
  templateUrl: './language-modal.component.html',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  styleUrls: [],
})
export class LanguageModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private readonly localizationService: LocalizationService,
  ) {}

  getAllLangs(): string[] {
    return this.localizationService.getSupportedLangs();
  }

  changeLang(lang: string) {
    this.localizationService.setLang(lang);
  }
}
